class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.drawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    let properties = {};

    const submitButton = this.querySelector('[type="submit"]');

    const lineItemPropertyInputs = document.querySelectorAll(
      'input[type="hidden"].line-item-property-input'
    );

    for (const input of lineItemPropertyInputs) {
      properties[input.dataset.name] = input.value;
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      properties,
      ...JSON.parse(serializeForm(this.form)),
      sections: ['cart-drawer'],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.drawer.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
               submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });

    affirm.ui.refresh();
  }
}

customElements.define('product-form', ProductForm);
